import { render, staticRenderFns } from "./VSelectServicio.vue?vue&type=template&id=37cbb9b8"
import script from "./VSelectServicio.vue?vue&type=script&lang=js"
export * from "./VSelectServicio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports